// Took the regex found here: https://stackoverflow.com/questions/10557441/regex-to-allow-atleast-one-special-character-one-uppercase-one-lowercasein-an
// and added a check for numbers (\d), and removed the 8 character match since we have a separate condition for that.
const passRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=*?!:;<>`{}|()[\]\\/"'_.~,-]).*$/
const MIN_PASS_LENGTH = 8
export default function (pass: string, email: string) {
  const messages = {
    errOnLength     : 'Please enter 8 or more characters',
    errOnSymbol     : 'Password must contain one number, symbol, capital letter, and lowercase letter',
    errOnEmailMatch : 'Password should not contain your username',
  }

  if (!pass || pass.length < MIN_PASS_LENGTH) {
    return messages.errOnLength
  }

  if (email && email.toLowerCase().includes(pass.toLowerCase())) {
    return messages.errOnEmailMatch
  }

  if (!pass.match(passRegex)) {
    return messages.errOnSymbol
  }

  return false
}
